import i18next from 'i18next';
import '../../locales/i18n'; // i18n 초기화를 위해 import

// 메뉴를 함수로 변경하여 언어 변경 시 동적으로 텍스트를 업데이트할 수 있도록 함
export const getMenu = () => {
  const t = (key: string) => i18next.t(key);

  return [
    {
      title: t('buySellCrypto'),
      link: '/buysell-crypto',
      dropdown: true,
      subMenu: [
        {
          title: t('buySellCrypto'),
          link: '/buysell-crypto',
          description: t('depositCryptoSecurely'),
        },
      ],
    },

    {
      title: t('futures') + ' ' + t('markets') + ' ' + t('overview'),
      link: '/markets',
      dropdown: true,
      subMenu: [
        {
          title: t('markets') + ' ' + t('overview'),
          link: '/markets',
          description: t('marketOverview'),
        },
        {
          title: t('fearGreedIndex'),
          link: '/fear-greed-index',
          description: t('cryptoFearGreedIndex'),
        },
      ],
    },
    {
      title: t('futures'),
      link: '/trade/2',
      dropdown: true,
      subMenu: [
        {
          title: t('usdtPerpetuals'),
          link: '/trade/2',
          description: t('perpetualContracts'),
        },
        // {
        //   title: "USDC Perpetuals",
        //   link: "/trade/2",
        //   description: "USDC-settled perpetuals.",
        // },
        // {
        //   title: "Inverse Perpetuals",
        //   link: "/trade/2",
        //   description: "Inverse perpetual trading.",
        // },
      ],
    },
    //
    // {
    // 	title: 'Deposit',
    // 	link: '/p2p',
    // 	dropdown: true,
    // 	subMenu: [
    // 		{
    // 			title: 'P2P',
    // 			link: '/p2p',
    // 			description: 'Direct peer-to-peer trading.',
    // 		},
    // 		{
    // 			title: 'One-click buy',
    // 			link: '/one-click-buy',
    // 			description: 'Buy crypto with one click.',
    // 		},
    // 		{
    // 			title: 'Crypto Deposit',
    // 			link: '/crypto',
    // 			description: 'Deposit crypto securely.',
    // 		},
    // 	],
    // },

    // {
    // 	title: 'Trade',
    // 	link: '/copytrade',
    // 	dropdown: true,
    // 	subMenu: [
    // 		{
    // 			title: 'Copy Trading',
    // 			link: '/copytrade',
    // 			description: 'Follow top traders.',
    // 		},
    // 		{
    // 			title: 'Bots',
    // 			link: '/bot-payment',
    // 			description: 'Automate your trades.',
    // 		},
    // 		{
    // 			title: 'Convert',
    // 			link: '/convert',
    // 			description: 'Automate your trades.',
    // 		},
    // 		{
    // 			title: 'Convert',
    // 			link: '/convert',
    // 			description: 'The easiest wa to trade at all sizes.',
    // 			inactive: true
    // 		},
    // 		{
    // 			title: 'Margin',
    // 			link: '/margin',
    // 			description: 'Leverage your trades.',
    // 			inactive: true
    // 		},
    // 		{
    // 			title: 'Spot',
    // 			link: '/spot',
    // 			description: 'Instant market trading.',
    // 			inactive: true
    // 		},
    // 	],
    // },

    // {
    // 	title: 'Futures',
    // 	link: '/futures',
    // 	dropdown: true,
    // 	subMenu: [
    // 		{
    // 			title: 'USDS-M Futures',
    // 			link: '/usds-m-futures',
    // 			description: 'USDS-M futures contracts.',
    // 		},
    // 		{
    // 			title: 'COIN-M Futures',
    // 			link: '/coin-m-futures',
    // 			description: 'Trade COIN-M futures.',
    // 		},
    // 		{
    // 			title: 'Unified Account',
    // 			link: '/unified-account',
    // 			description: 'Manage all in one.',
    // 			inactive: true
    // 		},
    // 	],
    // },
    {
      title: t('more'),
      link: '/about-us',
      dropdown: true,
      subMenu: [
        {
          title: t('aboutUs'),
          link: '/about-us',
          description: t('aboutUsDescription'),
        },
        {
          title: t('institutional'),
          link: '/institutional',
          description: t('institutionalDescription'),
        },
        {
          title: t('termsAndConditions'),
          link: '/terms-and-conditions',
          description: t('termsAndConditionsDescription'),
        },
        {
          title: t('guide'),
          link: '/guide',
          description: t('guideDescription'),
        },
        {
          title: t("noticeCenter"),
          link: "/notice",
          description: t("noticeCenterDescription"),
        },
        // {
        // 	title: 'Loans',
        // 	link: '/loan',
        // 	description: 'Crypto-backed loans.',
        // },
        // {
        // 	title: 'Referral',
        // 	link: '/referral',
        // 	description: 'Earn with referrals.',
        // },
        // {
        // 	title: 'Security of funds',
        // 	link: '/funds',
        // 	description: 'Top-tier fund security.',
        // },
        // {
        // 	title: 'Pay',
        // 	link: '/pay',
        // 	description: 'Send, receive and spend crypto.',
        // },
        // {
        // 	title: 'Earn',
        // 	link: '/earn',
        // 	description: 'Search popular coins and start earning.',
        // },
      ],
    },

    {
      title: t('eventRewards'),
      link: '/loan',
      dropdown: false,
    },
    {
      title: t('affiliateProgram'),
      link: '/referral',
      dropdown: false,
    },
    // {
    //   title: "Assets",
    //   link: "/assets",
    //   dropdown: false,
    // },
  ];
};

// Footer 메뉴도 함수로 변경
export const getFooterMenu = () => {
  const t = (key: string) => i18next.t(key);

  return [
    {
      title: t('buySellCrypto'),
      link: '/buysell-crypto',
      dropdown: true,
      subMenu: [
        {
          title: t('buySellCrypto'),
          link: '/buysell-crypto',
          description: t('depositCryptoSecurely'),
        },
      ],
    },

    {
      title: t('markets'),
      link: '/markets',
      dropdown: true,
      subMenu: [
        {
          title: t('markets') + ' ' + t('overview'),
          link: '/markets',
          description: t('marketOverview'),
        },
        {
          title: t('fearGreedIndex'),
          link: '/fear-greed-index',
          description: t('cryptoFearGreedIndex'),
        },
      ],
    },
    //   // subMenu: [
    //   //   {
    //   //     title: "Overview",
    //   //     link: "/markets",
    //   //     description: "Market Overview",
    //   //   },
    //   //   {
    //   //     title: "Trading Data",
    //   //     link: "/markets",
    //   //     description: "View Trading Data",
    //   //   },
    //   //   {
    //   //     title: "Ranking",
    //   //     link: "/leaderboard",
    //   //     description: "Market Ranking",
    //   //   },
    //   // ],
    // },
    // {
    //   title: "Deposit",
    //   link: "/p2p",
    //   dropdown: true,
    //   subMenu: [
    //     {
    //       title: "P2P",
    //       link: "/p2p",
    //       description: "Peer-to-Peer Trading",
    //     },
    //     // {
    //     //     title: 'Crypto Deposit',
    //     //     link: '/p2p',
    //     //     description: 'Deposit Crypto',
    //     // },
    //     {
    //       title: "One-click buy",
    //       link: "/one-click-buy",
    //       description: "Buy Crypto with One-click",
    //     },
    //   ],
    // },
    {
      title: t('futures'),
      link: '/trade/2',
      dropdown: true,
      subMenu: [
        {
          title: t('usdtPerpetuals'),
          link: '/trade/2',
          description: t('perpetualContracts'),
        },
        // {
        //   title: "USDC Perpetuals",
        //   link: "/trade/2",
        //   description: "USDC Perpetual Contracts",
        // },
        // {
        //   title: "Inverse Perpetuals",
        //   link: "/trade/2",
        //   description: "Inverse Perpetual Contracts",
        // },
      ],
    },
    // {
    // 	title: 'Trade',
    // 	link: '/trade',
    // 	dropdown: true,
    // 	subMenu: [
    // 		{
    // 			title: 'Copy Trading',
    // 			link: '/copytrade',
    // 			description: 'Copy Trading Services',
    // 		},
    // 		// {
    // 		//     title: 'Convert',
    // 		//     link: '/trade',
    // 		//     description: 'Convert between Crypto',
    // 		// },
    // 		// {
    // 		//     title: 'Bots',
    // 		//     link: '/trade',
    // 		//     description: 'Trade using Bots',
    // 		// },
    // 	],
    // },
    // {
    //     title: 'Futures',
    //     link: '/trade',
    //     dropdown: true,
    //     subMenu: [
    //         {
    //             title: 'USDS-M Futures',
    //             link: '/trade',
    //             description: 'USDⓈ-M Futures Contracts',
    //         },
    //         {
    //             title: 'COIN-M Futures',
    //             link: '/trade',
    //             description: 'COIN-M Futures Contracts',
    //         },
    //         {
    //             title: 'Perpetual Futures',
    //             link: '/trade',
    //             description: 'Perpetual Futures Contracts',
    //         },
    //     ],
    // },
    {
      title: t('more'),
      link: '/about-us',
      dropdown: true,
      subMenu: [
        {
          title: t('aboutUs'),
          link: '/about-us',
          description: t('aboutUsDescription'),
        },
        {
          title: t('institutional'),
          link: '/institutional',
          description: t('institutionalDescription'),
        },
        {
          title: t('termsAndConditions'),
          link: '/terms-and-conditions',
          description: t('termsAndConditionsDescription'),
        },
        // {
        //   title: "Referral",
        //   link: "/referral",
        //   description: "Earn with referrals.",
        // },
        // {
        //   title: "Copy Trading",
        //   link: "/copytrade",
        //   description: "Copy Trading Services",
        // },
        // {
        //   title: "Loans",
        //   link: "/loan",
        //   description: "Crypto-backed loans.",
        // },
        // {
        //   title: "Bots",
        //   link: "/bot-payment",
        //   description: "Automate your trades.",
        // },
        // {
        //   title: "Pay",
        //   link: "/pay",
        //   description: "Send, receive and spend crypto.",
        // },
        // {
        //   title: "Earn",
        //   link: "/earn",
        //   description: "Search popular coins and start earning.",
        // },
        // {
        //   title: "Convert",
        //   link: "/convert",
        //   description: "Automate your trades.",
        // },
        // {
        //     title: 'Loans',
        //     link: '/loans',
        //     description: 'Loan Services',
        // 	inactive: true
        // },
      ],
    },
    {
      title: t('eventRewards'),
      link: '/loan',
      dropdown: false,
      subMenu: [],
    },
    {
      title: t('affiliateProgram'),
      link: '/referral',
      dropdown: false,
      subMenu: [],
    },
    {
      title: t('CustomerService'),
      link: '/',
      dropdown: true,
      subMenu: [
        {
          title: t('mmr'),
          link: '/leverage-margin',
        },
      ],
    },
  ];
};

// 실시간 메뉴 업데이트를 위해 getter 함수만 export
export const Menu = getMenu();
export const FooterMenu = getFooterMenu();

// i18next 언어 변경 이벤트 리스너 추가
i18next.on('languageChanged', () => {
  // 언어 변경 시 Menu와 FooterMenu 업데이트
  Object.assign(Menu, getMenu());
  Object.assign(FooterMenu, getFooterMenu());
});
